import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadUpgradeBannerListCompletion } from '../../actions';

export function* watchLoadUpgradeBannerList() {
  yield takeEvery('LOAD_UPGRADE_BANNER_LIST', function*() {
    const options = {
      url: '/api/member/banner',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadUpgradeBannerListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export default function* upgradeSaga() {
  yield all([fork(watchLoadUpgradeBannerList)]);
}
